import { render } from "./market.vue?vue&type=template&id=d18e84bc"
import script from "./market.vue?vue&type=script&lang=js"
export * from "./market.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__